module.exports = __webpack_public_path__ + "static/media/super inter san fernando-100.f230625b.jpg";